import { render, staticRenderFns } from "./material-category-select.vue?vue&type=template&id=3c398d84&"
import script from "./material-category-select.vue?vue&type=script&lang=js&"
export * from "./material-category-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports